<script lang="ts">
	import { type Snapshot } from "luxedo-data"
	import { onMount } from "svelte"
	import { DateTime } from "luxon"
	import { triggerContextMenuWithGenerator } from "context-menu"
	import DownloadIcon from "../../icons/DownloadIcon.svelte"
	import { Responsive } from "responsive"
	import { CTXOptions } from "../../../../modules/ctx-menu/ContextMenuOptions"

	interface Props {
		snapshot: Snapshot
		canDelete?: boolean
		isSelected?: boolean
		onClick?: () => void
	}

	let { snapshot, isSelected = false, onClick = undefined }: Props = $props()
	let dateString: string = $state()

	let isMobile = $derived(Responsive.isMobile)

	onMount(() => {
		const dt = DateTime.fromJSDate(snapshot.datesaved)
		dateString = dt.toLocaleString(DateTime.DATE_SHORT)
	})
</script>

<div
	class="tile-container {isSelected ? 'is-selected' : ''}"
	class:isMobile
	role="button"
	tabindex="0"
	oncontextmenu={triggerContextMenuWithGenerator(CTXOptions.Snapshot.createOptions, [snapshot])}
	onkeydown={undefined}
	onclick={onClick ? onClick : () => CTXOptions.Snapshot.viewSnapshotOverlay(snapshot)}
>
	<div class="tile">
		<img src={snapshot.src} alt="" crossorigin="anonymous" />
	</div>
	<div class="tile-label-container">
		<span class="tile-label snapshot-label">
			<span>
				{dateString}
			</span>
			<button
				title="download"
				class="icon small download-btn"
				onclick={(e) => {
					e.preventDefault()
					snapshot.triggerDownload()
				}}
			>
				<DownloadIcon />
			</button>
		</span>
	</div>
</div>

<style>
	.snapshot-label {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.isMobile .snapshot-label {
		font-size: var(--h3);
	}

	.download-btn {
		padding: 0;
	}

	button.icon.small.download-btn > :global(svg) {
		height: 1.25rem;
	}

	.download-btn :global(.svg-fill) {
		fill: var(--color-text);
	}

	.download-btn:hover :global(.svg-fill),
	.download-btn:focus-visible :global(.svg-fill) {
		fill: var(--color-text-light);
	}
</style>
